import { FEEL_BY_ID, FLAVOR_BY_ID, STYLE_BY_ID } from '../../../vibe/definitions';

function namedItems(ids, byId) {
  if (!Array.isArray(ids)) return [];
  return ids.map((id) => byId[id]).filter(Boolean);
}

/**
 * Lightweight summary of the current user's saved vibe.
 * Not a second Crowd orb.
 */
export default function MyVibeSummary({ preference, onEdit }) {
  const feel = FEEL_BY_ID[preference?.feelId];
  const styles = namedItems(preference?.styleIds, STYLE_BY_ID);
  const flavors = namedItems(preference?.flavorIds, FLAVOR_BY_ID);

  if (!feel) return null;

  return (
    <section aria-label="My Vibe" className="w-full min-w-0">
      <h3 className="mb-3 text-base font-semibold text-white">My Vibe</h3>
      <p className="flex items-center gap-2 text-sm font-medium text-white">
        <span
          aria-hidden="true"
          className="inline-block h-2.5 w-2.5 shrink-0 rounded-full"
          style={{ backgroundColor: feel.color, boxShadow: `0 0 8px ${feel.color}` }}
        />
        <span>{feel.label}</span>
      </p>
      {styles.length > 0 ? (
        <ul className="mt-3 flex flex-wrap gap-1.5" aria-label="My styles">
          {styles.map((style) => (
            <li
              key={style.id}
              className="rounded-full border border-white/20 px-2 py-0.5 text-xs text-white/90"
            >
              {style.label}
            </li>
          ))}
        </ul>
      ) : null}
      {flavors.length > 0 ? (
        <ul className="mt-2 flex flex-wrap gap-1.5" aria-label="My flavors">
          {flavors.map((flavor) => (
            <li
              key={flavor.id}
              className="rounded-full border border-white/15 px-2 py-0.5 text-xs text-white/80"
            >
              {flavor.label}
            </li>
          ))}
        </ul>
      ) : null}
      {onEdit ? (
        <button
          type="button"
          onClick={onEdit}
          className="mt-4 w-full rounded-lg border border-white/20 py-2.5 text-sm font-medium text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          Edit My Vibe
        </button>
      ) : null}
    </section>
  );
}
